import React from 'react';
export default function Button(props) {
  return /*#__PURE__*/React.createElement("button", Object.assign({
    type: "button",
    style: {
      color: 'red'
    }
  }, props));
}